import { render, staticRenderFns } from "./AlarmNotificationDialog.vue?vue&type=template&id=0c181a6a&"
import script from "./AlarmNotificationDialog.vue?vue&type=script&lang=ts&"
export * from "./AlarmNotificationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports